import axios from 'axios';

const axiosInstance = axios.create();

export default {
    getReports: () => {
        return axiosInstance.get('/api/TableauViews/Menu')
    },
    getFolders: () => {
        return axiosInstance.get('/api/TableauViews/Folder')
    },
    getToken: () => {
        return axiosInstance.get('/api/TableauViews/AccessToken')
    },
}